import styled from 'styled-components';
import indents from '../../constants/js/indents.js';
import breakpoints from '../../constants/js/breakpoints.js';
import text from '../../constants/js/text.js';
import { textSize, skinColor } from './constants';
const StyledInputLabel = styled.label.withConfig({
  componentId: "InputLabel__sc-gkv10e-0"
})(["display:block;color:", ";", " ", " ", " ", " ", ""], ({
  skin = 'light',
  isDisabled
}) => skinColor[skin][isDisabled ? 'disabled' : 'default'], ({
  size,
  isFloating
}) => !size && !isFloating && `
			font-size: ${text.fontSize7};
			line-height: ${text.lineHeight7};

			@media (min-width: ${breakpoints.md}) {
				font-size: ${text.fontSize6};
				line-height: ${text.lineHeight6};
			}
		`, ({
  size
}) => size && textSize[size], ({
  isRightIcon
}) => isRightIcon && `padding: 0 ${indents.indentXL} 0 ${indents.indentS};`, ({
  isFloating
}) => isFloating && `
			transition: all 0.2s;
			transform: translateY(-50%);
			position: absolute;
			top: 50%;
			left: 0;
			padding: 0 ${indents.indentS} 0 ${indents.indentS};
			box-sizing: border-box;
			pointer-events: none;
			width: 100%;
			white-space: nowrap;
			overflow: hidden;
			text-overflow: ellipsis;
			z-index: 1;
    `, ({
  isShrink
}) => isShrink && `
			font-size: ${text.fontSize7};
			line-height: ${text.lineHeight7};
			top: ${indents.indentXS};
			transform: none;
		`);
export { StyledInputLabel };